import _ from "axios";
import * as e from "zod";
import { z as t } from "zod";
import { fromZodError as j } from "zod-validation-error";
import { LocalStorage as A } from "@made-people/local-storage";
const V = {
  debug(...r) {
  }
};
var i = /* @__PURE__ */ ((r) => (r.POST = "post", r.GET = "get", r.PATCH = "patch", r.PUT = "put", r.DELETE = "delete", r))(i || {});
class Q {
  constructor(n) {
    this.options = n, this.logger = this.options.logger || V, this.client = this.getAxiosClient();
  }
  getAxiosClient() {
    let n = {};
    if (this.options.centraTokenHandler) {
      const s = this.options.centraTokenHandler.getToken();
      n = s ? {
        "API-Token": s
      } : {};
    }
    const o = _.create({
      baseURL: this.options.baseUrl,
      timeout: this.options.transport.timeout,
      headers: n
    });
    return o.interceptors.request.use((s) => (this.options.centraTokenHandler && (s.headers["API-Token"] = this.options.centraTokenHandler.getToken()), s)), o.interceptors.response.use((s) => {
      var u;
      return this.options.centraTokenHandler && ((u = s == null ? void 0 : s.data) != null && u.token) && this.options.centraTokenHandler.setToken(s.data.token), s;
    }), o;
  }
  async request(n) {
    var s;
    const o = {
      ...n,
      validateStatus: () => !0
    };
    return (s = this.logger) == null || s.debug(`Making request ${JSON.stringify(o)}`), await this.client.request(o).then((u) => u);
  }
}
function G(r) {
  return new Q({ ...K(), ...r });
}
function K() {
  return {
    transport: {
      timeout: 6e4
    }
  };
}
const w = t.object({
  key: t.string(),
  consented: t.boolean(),
  name: t.string().optional(),
  text: t.string().optional(),
  version: t.string().optional(),
  language: t.string().optional()
}), J = t.object({
  email: t.string(),
  password: t.string(),
  firstName: t.string(),
  lastName: t.string(),
  address1: t.string().optional(),
  address2: t.string().optional(),
  zipCode: t.string().optional(),
  city: t.string().optional(),
  state: t.string().optional(),
  country: t.string().optional(),
  phoneNumber: t.string().optional(),
  newsletter: t.boolean().optional(),
  language: t.string().optional(),
  consents: t.array(w).optional()
}), q = t.object({
  address1: t.string(),
  address2: t.string(),
  city: t.string(),
  consents: t.array(
    t.object({
      key: t.string(),
      consented: t.boolean()
    })
  ).optional(),
  country: t.string(),
  email: t.string(),
  firstName: t.string(),
  lastName: t.string(),
  phoneNumber: t.string(),
  state: t.string(),
  zipCode: t.string(),
  // Do these actually exist in the response?
  gender: t.string().optional(),
  language: t.string().optional().nullable(),
  newsletter: t.boolean().optional()
}), k = q.extend({
  customer: t.string()
}), h = t.object({
  language: t.string(),
  name: t.string(),
  default: t.boolean()
}), y = t.object({
  country: t.string(),
  name: t.string(),
  eu: t.boolean(),
  language: t.string(),
  currency: t.string(),
  states: t.array(
    t.object({
      state: t.string(),
      name: t.string()
    })
  ).optional()
}), S = t.object({
  country: t.string(),
  name: t.string(),
  state: t.union([t.string(), t.null()]),
  stateName: t.string(),
  eu: t.boolean(),
  shipTo: t.boolean(),
  language: h,
  market: t.number(),
  pricelist: t.number()
}), f = t.object({
  email: t.string(),
  firstName: t.string(),
  lastName: t.string(),
  company: t.string(),
  address1: t.string(),
  address2: t.string(),
  zipCode: t.string(),
  city: t.string(),
  country: t.string(),
  phoneNumber: t.string(),
  state: t.string().optional(),
  vatNumber: t.string().optional()
}), X = t.object({
  category: t.string(),
  name: t.array(t.string()),
  sortOrder: t.number(),
  uri: t.string(),
  attributes: t.union([t.array(t.unknown()), t.record(t.string(), t.unknown())]).optional(),
  pathIds: t.array(t.string()).optional()
}), Y = t.object({
  media: t.number(),
  sources: t.any(),
  attributes: t.any(),
  altText: t.string().optional()
}), Z = t.object({
  periodDays: t.number(),
  price: t.string(),
  priceAsNumber: t.number(),
  priceBeforeDiscount: t.string(),
  priceBeforeDiscountAsNumber: t.number()
}), tt = t.object({
  sizeId: t.string(),
  item: t.string(),
  ean: t.string(),
  itemTableX: t.number(),
  itemTableY: t.number(),
  name: t.string(),
  upc: t.string().optional(),
  sku: t.string(),
  stock: t.string().or(t.number()).optional()
  // This can be a string (Yes/No) or a number (Stock in quantity), depending on settings in Centra Checkout API
}), et = t.object({
  priceType: t.string(),
  type: t.string(),
  priceOfItems: t.string(),
  priceMin: t.string(),
  priceMax: t.string(),
  priceOfItemsAsNumber: t.number(),
  priceMinAsNumber: t.number(),
  priceMaxAsNumber: t.number(),
  priceMinBeforeDiscountAsNumber: t.number(),
  priceMaxBeforeDiscountAsNumber: t.number(),
  priceMinBeforeDiscount: t.string(),
  priceMaxBeforeDiscount: t.string(),
  discount: t.number()
}), nt = t.object({
  unit: t.string(),
  x: t.union([t.record(t.string()), t.array(t.string())]),
  y: t.union([t.record(t.string()), t.array(t.string())]),
  dividerSymbol: t.string()
}), x = t.object({
  product: t.string(),
  name: t.string(),
  uri: t.string(),
  sku: t.string(),
  productSku: t.string(),
  brand: t.string(),
  brandName: t.string().nullable(),
  brandUri: t.string().nullable(),
  collection: t.string().optional().nullable(),
  collectionName: t.string().optional().nullable(),
  collectionUri: t.string().optional().nullable(),
  variantName: t.string(),
  countryOrigin: t.string().optional().nullable(),
  excerpt: t.string(),
  excerptHtml: t.string(),
  description: t.string(),
  descriptionHtml: t.string(),
  metaTitle: t.string(),
  metaDescription: t.string(),
  metaKeywords: t.string(),
  stockUnit: t.string(),
  category: t.string().nullable(),
  categoryName: t.array(t.string()).nullable(),
  createdAt: t.string(),
  modifiedAt: t.string(),
  categoryUri: t.string().nullable(),
  centraProduct: t.string(),
  centraVariant: t.string(),
  itemQuantityMinimum: t.number(),
  itemQuantityMultipleOf: t.number(),
  price: t.string(),
  priceAsNumber: t.number(),
  priceBeforeDiscount: t.string(),
  priceBeforeDiscountAsNumber: t.number(),
  discountPercent: t.number(),
  lowestPrice: t.array(Z),
  showAsOnSale: t.boolean(),
  showAsNew: t.boolean(),
  available: t.boolean().optional(),
  bundleInfo: et.optional(),
  tableMappings: t.record(t.string(), nt).optional(),
  itemTable: t.object({
    unit: t.string(),
    original: t.object({
      x: t.array(t.string()).optional(),
      y: t.array(t.string()).optional()
    }),
    desc: t.string().optional(),
    x: t.array(t.string()),
    y: t.array(t.string()),
    dividerSymbol: t.string()
  }),
  items: t.array(tt),
  categories: t.array(X).optional(),
  media: t.any(),
  mediaObjects: t.array(Y),
  mediaUrls: t.array(t.string()).optional(),
  relation: t.string().optional(),
  subscriptionPlans: t.array(t.any()).optional()
}).passthrough(), rt = x.extend({
  relation: t.string()
}), b = x.extend({
  relatedProducts: t.array(rt).optional()
}), ot = e.object({
  bundle: e.number(),
  type: e.enum(["fixed", "flexible"]),
  priceType: e.enum(["static", "dynamic"]),
  priceOfItems: e.string(),
  priceOfItemsAsNumber: e.number(),
  minPrice: e.string(),
  minPriceAsNumber: e.number(),
  maxPrice: e.string(),
  maxPriceAsNumber: e.number()
}), st = e.object({
  bundleInfo: ot,
  sections: e.array(
    e.object({
      section: e.string(),
      quantity: e.number(),
      products: e.array(e.number())
    })
  )
}), it = e.object({
  anyDiscount: e.boolean(),
  brandName: e.string(),
  category: e.string().optional().nullable(),
  comment: e.string().nullable(),
  discounts: e.any().nullable(),
  ean: e.string(),
  item: e.string(),
  priceEach: e.string(),
  priceEachAsNumber: e.number(),
  priceEachBeforeDiscount: e.string(),
  priceEachBeforeDiscountAsNumber: e.number(),
  priceEachWithoutTax: e.string(),
  priceEachWithoutTaxAsNumber: e.number(),
  product: e.string(),
  productName: e.string(),
  productUri: e.string().optional().nullable(),
  quantity: e.number(),
  silkProduct: e.string(),
  silkVariant: e.string(),
  size: e.string(),
  sku: e.string(),
  taxPercent: e.number(),
  totalPrice: e.string(),
  totalPriceAsNumber: e.number(),
  totalPriceBeforeDiscount: e.string(),
  totalPriceBeforeDiscountAsNumber: e.number()
}), at = e.object({
  item: e.string(),
  productUrl: e.union([e.string(), e.null()]),
  category: e.string(),
  size: e.string(),
  sku: e.string(),
  ean: e.string(),
  quantity: e.number(),
  comment: e.string(),
  line: e.string(),
  priceEach: e.string(),
  priceEachAsNumber: e.number(),
  totalPrice: e.string(),
  totalPriceAsNumber: e.number(),
  priceEachBeforeDiscount: e.string(),
  priceEachBeforeDiscountAsNumber: e.number(),
  anyDiscount: e.boolean(),
  taxPercent: e.number(),
  priceEachWithoutTax: e.string(),
  priceEachWithoutTaxAsNumber: e.number(),
  totalPriceBeforeDiscount: e.string(),
  totalPriceBeforeDiscountAsNumber: e.number(),
  totalPriceAfterDiscount: e.string(),
  totalPriceAfterDiscountAsNumber: e.number(),
  product: b,
  bundle: st,
  subscriptionPlan: e.any()
}), E = e.object({
  item: e.string(),
  productUrl: e.union([e.string(), e.null()]),
  category: e.union([e.string(), e.null()]).nullable(),
  campaign: e.object({
    discount: e.string(),
    discountAsNumber: e.number(),
    name: e.string()
  }).optional(),
  size: e.string(),
  sku: e.string(),
  ean: e.string(),
  quantity: e.number(),
  comment: e.union([e.string(), e.null()]).nullable(),
  line: e.string(),
  priceEach: e.string(),
  priceEachAsNumber: e.number(),
  totalPrice: e.string(),
  totalPriceAsNumber: e.number(),
  priceEachBeforeDiscount: e.string(),
  priceEachBeforeDiscountAsNumber: e.number(),
  totalPriceAfterDiscount: e.string(),
  totalPriceAfterDiscountAsNumber: e.number(),
  anyDiscount: e.boolean(),
  taxPercent: e.number(),
  priceEachWithoutTax: e.string(),
  priceEachWithoutTaxAsNumber: e.number(),
  totalPriceBeforeDiscount: e.string(),
  totalPriceBeforeDiscountAsNumber: e.number(),
  product: b,
  bundle: e.array(it).optional(),
  bundleReference: e.string().optional(),
  subscriptionPlan: e.any()
}), R = e.object({
  currency: e.string(),
  name: e.string(),
  prefix: e.string(),
  suffix: e.string(),
  decimalPoint: e.string(),
  decimalDigits: e.string(),
  thousandsSeparator: e.string(),
  uri: e.string()
}), ct = e.union([
  E,
  at
]), M = e.object({
  // Seems to always be '2', but since we don't know what this number means we can't turn it into
  // a literal without breaking checkout.
  version: e.number(),
  snippet: e.string().optional(),
  session_id: e.string().optional(),
  ingridAttributes: e.any(),
  deliveryOptionsAvailable: e.boolean()
}), lt = e.object({
  paymentHTML: e.string().optional(),
  klarnaReplaceSnippet: e.boolean().optional(),
  ingrid: M.optional(),
  shipwallet: M.optional()
}), v = e.object({
  voucher: e.string(),
  type: e.enum(["code", "uri", "other"]).optional(),
  description: e.string(),
  priceOff: e.string(),
  hasAffectedOrder: e.boolean(),
  priceOffAsNumber: e.number()
}), ut = e.object({
  automaticDiscount: e.string().or(e.number()),
  hasAffectedOrder: e.boolean(),
  name: e.string(),
  priceOff: e.string(),
  priceOffAsNumber: e.number(),
  freeShippingFor: e.array(e.string()).optional()
}), B = e.object({
  affiliateHtml: e.string().optional(),
  giftMessage: e.string().optional(),
  language: e.string(),
  currency: e.string(),
  paymentMethod: e.string(),
  paymentMethodName: e.string(),
  shippingMethod: e.string(),
  shippingMethodName: e.string(),
  pluginFields: lt.optional(),
  centraCheckoutScript: e.string().optional().nullable(),
  // Optional but added to the schema when Qliro is selected as payment method
  qliroReplaceSnippet: e.boolean().optional(),
  // Optional but added to the schema an iframe payment method is configured for the selection
  paymentHTML: e.string().optional(),
  items: e.array(ct),
  discounts: e.object({
    anyDiscount: e.boolean(),
    discount: e.string(),
    discountAsNumber: e.number(),
    automaticDiscounts: e.array(ut),
    vouchers: e.array(v)
  }),
  totals: e.object({
    itemsTotalPrice: e.string(),
    itemsTotalPriceAsNumber: e.number(),
    totalDiscountPrice: e.union([e.string(), e.boolean(), e.number()]),
    totalDiscountPriceAsNumber: e.union([e.number(), e.boolean()]),
    shippingPrice: e.string(),
    shippingPriceAsNumber: e.number(),
    handlingCostAddedToShippingPrice: e.boolean().optional(),
    totalQuantity: e.number(),
    taxDeducted: e.union([e.string(), e.boolean()]),
    taxDeductedAsNumber: e.union([e.number(), e.boolean()]),
    taxAdded: e.union([e.string(), e.boolean()]),
    taxAddedAsNumber: e.union([e.number(), e.boolean()]),
    taxPercent: e.number(),
    grandTotalPrice: e.string(),
    grandTotalPriceAsNumber: e.number(),
    grandTotalPriceTax: e.string(),
    grandTotalPriceTaxAsNumber: e.number()
  }),
  vatExempt: e.boolean(),
  additionalNotes: e.string(),
  address: f,
  shippingAddress: f,
  currencyFormat: R.extend({
    denominator: e.number().optional()
  })
}), U = e.object({
  paymentMethod: e.string(),
  name: e.string(),
  clientSide: e.object({
    externalScript: e.string().optional()
  }).optional(),
  handlingCost: e.string(),
  handlingCostAsNumber: e.number(),
  providesCustomerAddressAfterPayment: e.boolean(),
  paymentMethodType: e.string()
}), c = e.object({
  type: e.string(),
  visible: e.boolean(),
  required: e.boolean()
}), F = e.object({
  termsAndConditions: c,
  address: e.object({
    email: c,
    company: c,
    firstName: c,
    lastName: c,
    address1: c,
    address2: c,
    zipCode: c,
    city: c,
    state: c,
    country: c,
    phoneNumber: c,
    identityNumber: c,
    vatNumber: c,
    houseNumber: c,
    houseExtension: c,
    newsletter: c
  }),
  shippingAddress: e.object({
    email: c,
    company: c,
    firstName: c,
    lastName: c,
    address1: c,
    address2: c,
    zipCode: c,
    city: c,
    state: c,
    country: c,
    phoneNumber: c,
    houseNumber: c,
    houseExtension: c
  })
}), $ = e.object({
  shippingMethod: e.string(),
  name: e.string(),
  price: e.string(),
  priceAsNumber: e.number()
}), p = e.object({
  token: e.string(),
  selection: B,
  languages: e.array(h),
  paymentMethods: e.array(U),
  paymentFields: F,
  shippingMethods: e.array($),
  countries: e.array(y),
  loggedIn: k.optional(),
  location: S
});
function a(r, n, o, s) {
  if (r.status >= 200 && r.status <= 299) {
    const u = n.safeParse(r.data);
    if (!u.success)
      throw new Error(
        `[${s}] Error parsing Success Response: ${j(
          u.error
        ).toString()}`
      );
    return { success: u.data, error: null };
  } else {
    const u = o.safeParse(r.data);
    if (!u.success)
      throw new Error(
        `[${s}] Error parsing Error Response: ${j(
          u.error
        ).toString()}`
      );
    return { success: null, error: u.data };
  }
}
const g = t.object({
  token: t.string()
}), pt = e.record(e.string()), l = g.extend({
  errors: pt
});
function m(r, n, o) {
  const s = r.safeParse(n);
  s.success || console.error(
    `[${o}] Error parsing input: ${j(s.error).toString()}`
  );
}
const mt = (r) => async (n) => {
  m(J, n, "register");
  const o = await r.transporter.request({
    url: "/register",
    data: n,
    method: i.POST
  });
  return a(
    o,
    p,
    l,
    "register"
  );
};
function P(r) {
  return encodeURIComponent(decodeURIComponent(r));
}
const dt = (r) => async (n, o) => {
  const s = await r.transporter.request({
    url: `/login/${P(n)}`,
    data: {
      password: o
    },
    method: i.POST
  });
  return a(
    s,
    p,
    l,
    "login"
  );
}, z = e.object({
  order: e.string(),
  items: E.array(),
  status: e.enum(["untouched", "progress", "ok", "archived", "failed"]).optional(),
  statusDescription: e.enum([
    "Pending",
    "Confirmed",
    "Processing",
    "Completed",
    "Archived",
    "Canceled",
    "Incomplete"
  ]).optional(),
  date: e.string().optional(),
  giftMessage: e.string().optional(),
  shipments: e.array(
    e.object({
      shipmentId: e.string().optional(),
      shippedDate: e.string().optional(),
      carrier: e.string().optional(),
      service: e.string().optional(),
      trackingId: e.string().optional(),
      trackingUrl: e.string().optional(),
      returnSlipTracking: e.string().optional(),
      additionalMessage: e.string().nullable().optional()
    })
  ).optional(),
  language: e.string().nullable().optional(),
  currency: e.string().nullable().optional(),
  paymentMethod: e.string(),
  paymentMethodName: e.string(),
  paymentMethodData: e.object({
    snippet: e.string().optional()
  }).optional(),
  shippingMethod: e.string(),
  shippingMethodName: e.string(),
  pluginFields: e.record(e.any()).optional(),
  centraCheckoutScript: e.string().optional(),
  discounts: e.object({
    anyDiscount: e.boolean().optional(),
    discount: e.string().optional(),
    discountAsNumber: e.number().optional(),
    vouchers: e.array(v).optional()
  }).optional(),
  currencyFormat: R,
  totals: e.object({
    itemsTotalPrice: e.string(),
    itemsTotalPriceAsNumber: e.number(),
    totalDiscountPrice: e.union([e.string(), e.boolean(), e.number()]),
    totalDiscountPriceAsNumber: e.union([e.number(), e.boolean()]),
    shippingPrice: e.string(),
    shippingPriceAsNumber: e.number(),
    handlingCostAddedToShippingPrice: e.boolean().optional(),
    totalQuantity: e.number(),
    taxDeducted: e.union([e.string(), e.boolean()]),
    taxDeductedAsNumber: e.union([e.number(), e.boolean()]),
    taxAdded: e.union([e.string(), e.boolean()]),
    taxAddedAsNumber: e.union([e.number(), e.boolean()]),
    taxPercent: e.number(),
    grandTotalPrice: e.string(),
    grandTotalPriceAsNumber: e.number(),
    grandTotalPriceTax: e.string(),
    grandTotalPriceTaxAsNumber: e.number(),
    totalOriginalDiscountPrice: e.union([e.string(), e.boolean()]),
    totalOriginalDiscountPriceAsNumber: e.union([e.number(), e.boolean()])
  }),
  vatExempt: e.boolean().optional(),
  additionalNotes: e.string().optional(),
  address: e.object({
    email: e.string().optional(),
    firstName: e.string().optional(),
    lastName: e.string().optional(),
    company: e.string().optional(),
    address1: e.string().optional(),
    address2: e.string().optional(),
    zipCode: e.string().optional(),
    city: e.string().optional(),
    state: e.string().optional(),
    country: e.string().optional(),
    countryName: e.string().optional(),
    phoneNumber: e.string().optional(),
    vatNumber: e.string().optional()
  }).optional(),
  shippingAddress: e.object({
    email: e.string().optional(),
    firstName: e.string().optional(),
    lastName: e.string().optional(),
    company: e.string().optional(),
    address1: e.string().optional(),
    address2: e.string().optional(),
    zipCode: e.string().optional(),
    city: e.string().optional(),
    state: e.string().optional(),
    country: e.string().optional(),
    countryName: e.string().optional(),
    phoneNumber: e.string().optional()
  }).optional()
}), gt = t.object({
  from: t.number(),
  size: t.number(),
  totalSize: t.number()
}), C = t.object({
  countries: t.array(y),
  languages: t.array(h),
  location: S,
  loggedIn: q,
  orders: t.array(z),
  ordersPaging: gt,
  token: t.string()
}), bt = (r) => async () => {
  const n = await r.transporter.request({
    url: "/orders",
    method: i.POST
  }), o = C.extend({
    orders: e.array(e.any())
  }), s = a(
    n,
    o,
    l,
    "getCustomerOrders"
  );
  if (!s.success)
    return s;
  const u = s.success.orders.map((d) => {
    const T = C.shape.orders.element.safeParse(d);
    return T.success ? T.data : (console.warn("Invalid order format for order:", T.error), null);
  }).filter((d) => d !== null);
  return {
    success: {
      ...s.success,
      orders: u
    },
    error: null
  };
}, ht = (r) => async () => {
  const n = await r.transporter.request({
    url: "/logout",
    method: i.POST
  });
  return a(
    n,
    p,
    l,
    "logout"
  );
}, yt = t.object({
  firstName: t.string(),
  lastName: t.string(),
  newEmail: t.string().optional(),
  address1: t.string().optional(),
  address2: t.string().optional(),
  zipCode: t.string().optional(),
  city: t.string().optional(),
  state: t.string().optional(),
  country: t.string().optional(),
  phoneNumber: t.string().optional(),
  newsletter: t.boolean().optional(),
  language: t.string().optional(),
  consents: t.array(w).optional()
}), ft = (r) => async (n) => {
  m(yt, n, "updateCustomerInfo");
  const o = await r.transporter.request({
    url: "/customer/update",
    data: n,
    method: i.PUT
  });
  return a(
    o,
    p,
    l,
    "updateCustomerInfo"
  );
}, St = (r) => async (n) => {
  const o = await r.transporter.request({
    url: "/email",
    data: { newEmail: P(n) },
    method: i.PUT
  });
  return a(
    o,
    p,
    l,
    "updateCustomerEmail"
  );
}, Pt = t.object({
  newPassword: t.string(),
  i: t.string(),
  id: t.string()
}), Nt = (r) => async (n) => {
  m(Pt, n, "resetPassword");
  const o = await r.transporter.request({
    url: "/password-reset",
    data: n,
    method: i.POST
  });
  return a(
    o,
    p,
    l,
    "resetPassword"
  );
}, Tt = (r) => async (n, o) => {
  const s = await r.transporter.request({
    url: "/password-reset-email",
    data: {
      email: n,
      linkUri: o
    },
    method: i.POST
  });
  return a(
    s,
    p,
    l,
    "sendResetPasswordEmail"
  );
}, At = (r) => async (n, o) => {
  const s = await r.transporter.request({
    url: "/password",
    data: {
      password: n,
      newPassword: o
    },
    method: i.PUT
  });
  return a(
    s,
    p,
    l,
    "updatePassword"
  );
}, I = t.object({
  items: t.array(
    t.object({
      createdAt: t.string(),
      product: t.number(),
      wishlistItem: t.number()
    })
  ),
  token: t.string()
}), jt = "0", O = (r) => `/customer/wishlists/${r ?? jt}`, wt = (r) => async (n) => {
  const o = await r.transporter.request({
    url: O(n == null ? void 0 : n.wishlist),
    data: {
      limit: n == null ? void 0 : n.limit,
      page: n == null ? void 0 : n.page
    },
    method: i.POST
  });
  return a(
    o,
    I,
    l,
    "addWishlistItem"
  );
}, kt = (r) => async (n) => {
  const o = await r.transporter.request({
    url: `${O(n.wishlist)}/items/${n.item}`,
    method: i.POST
  });
  return a(
    o,
    I,
    l,
    "addWishlistItem"
  );
}, It = (r) => async (n) => {
  const o = await r.transporter.request({
    url: `${O(n.wishlist)}/items/${n.item}`,
    method: i.DELETE
  });
  return a(
    o,
    I,
    l,
    "addWishlistItem"
  );
}, Ot = (r) => async () => {
  const n = await r.transporter.request({
    url: "/customer",
    method: i.GET
  });
  return a(
    n,
    k,
    l,
    "getCustomerData"
  );
}, Mt = (r) => async () => {
  const n = await r.transporter.request({
    url: "/selection",
    method: i.GET
  });
  return a(
    n,
    p,
    l,
    "getSelection"
  );
}, D = t.object({
  email: t.string().optional(),
  firstName: t.string().optional(),
  lastName: t.string().optional(),
  company: t.string().optional(),
  address1: t.string().optional(),
  address2: t.string().nullable().optional(),
  zipCode: t.string().optional(),
  city: t.string().optional(),
  country: t.string(),
  phoneNumber: t.string().optional(),
  state: t.string().optional(),
  vatNumber: t.string().optional()
}), W = t.object({
  paymentFailedPage: t.string().optional(),
  paymentReturnPage: t.string().optional(),
  ipAddress: t.string().optional(),
  address: D.optional(),
  shippingAddress: D.optional(),
  termsAndConditions: t.boolean().optional(),
  paymentMethod: t.string().optional(),
  shippingMethod: t.string().optional(),
  // paymentInitiateOnly: Used for payment buttons, only initiate payment without selecting the payment method as current method.
  // It will still go through stock check, but it will not flip the current payment method of the selection.
  // Will allow plugins that supports the option to be initiated without providing address information.
  paymentInitiateOnly: t.boolean().optional(),
  clientDetails: t.object({
    browserLang: t.string().optional(),
    userAgent: t.string().optional(),
    ip: t.string().optional()
  }).optional(),
  consents: w.optional(),
  paymentMethodSpecificFields: t.unknown().optional(),
  additionalNotes: t.string().optional(),
  additionalFields: t.record(t.string(), t.unknown()).optional()
}), Ct = t.object({
  action: t.literal("form"),
  formHtml: t.string(),
  formType: t.enum([
    "adyen-drop-in",
    "qliro",
    "stripe-payment-intents",
    "paypal_commerce"
  ]).optional(),
  formFields: t.record(t.string(), t.unknown()).optional(),
  token: t.string()
}), Dt = t.object({
  action: t.literal("javascript"),
  formFields: t.record(t.string(), t.unknown()).optional(),
  code: t.string(),
  token: t.string()
}), qt = t.object({
  action: t.literal("redirect"),
  url: t.string(),
  token: t.string()
}), xt = t.object({
  action: t.literal("success"),
  token: t.string()
}), Et = t.discriminatedUnion("action", [
  Dt,
  qt,
  Ct,
  xt
]), Rt = g.extend({
  errors: t.object({
    stock: t.enum(["unavailable_items"]).optional()
  }).passthrough(),
  unavailableItems: t.array(
    t.object({
      available: t.number().describe("The available quantity of the item"),
      unavailable: t.number().describe(
        "The quantity of the item that isn't available for the cart item"
      ),
      item: t.string().describe("The Centra item number"),
      originalQuantity: t.number().describe(
        "The quantity of the item as it was before POST /payment"
      ),
      product: b
    })
  ).optional()
}), vt = g.extend({
  errors: t.object({
    paymentMethod: t.enum(["failed"]).optional()
  }).passthrough()
}), Bt = t.union([
  Rt,
  vt,
  t.object({
    selection: B.optional(),
    languages: t.array(h).optional(),
    paymentMethods: t.array(U).optional(),
    paymentFields: F.optional(),
    shippingMethods: t.array($).optional(),
    countries: t.array(y).optional(),
    loggedIn: k.optional(),
    location: S.optional()
  })
]), Ut = (r) => async (n) => {
  m(W, n, "postPayment");
  const o = await r.transporter.request({
    url: "/payment",
    data: n || {},
    method: i.POST
  });
  return a(
    o,
    Et,
    Bt,
    "postPayment"
  );
}, Ft = t.object({
  order: z,
  location: S,
  languages: t.array(h),
  countries: t.array(y),
  token: t.string()
}), $t = t.object({
  errors: t.object({
    selection: t.literal("not found").optional(),
    paymentMethod: t.literal("failed").optional()
  })
}), zt = t.union([
  $t,
  l
]), Wt = (r) => async (n) => {
  m(W, n, "paymentResult");
  const o = await r.transporter.request({
    url: "/payment-result",
    data: n || {},
    method: i.POST
  });
  return a(
    o,
    Ft,
    zt,
    "paymentResult"
  );
}, Ht = t.object({
  address: f.partial().optional(),
  shippingAddress: f.partial().optional(),
  language: t.string().optional(),
  paymentReturnPage: t.string().optional(),
  paymentFailedPage: t.string().optional(),
  additionalFields: t.record(t.string(), t.unknown()).optional(),
  additionalNotes: t.string().optional(),
  cartAbandonmentEmail: t.boolean().optional()
}), Lt = (r) => async (n) => {
  m(
    Ht,
    n,
    "paymentFieldsUpdate"
  );
  const o = await r.transporter.request({
    url: "/payment-fields",
    data: n || {},
    method: i.PUT
  });
  return a(
    o,
    p,
    l,
    "paymentFieldsUpdate"
  );
}, _t = t.object({
  shipTo: t.object({
    country: t.string().optional(),
    state: t.string().optional()
  }).optional(),
  language: t.string().optional()
}), Vt = (r) => async (n, o, s) => {
  const u = P(n);
  m(
    _t,
    s,
    "subscribeToBackInStock"
  );
  const d = await r.transporter.request({
    url: "/back-in-stock-subscription",
    data: {
      email: u,
      item: o,
      ...s
    },
    method: i.POST
  });
  return a(
    d,
    g,
    l,
    "subscribeToBackInStock"
  );
}, Qt = t.object({
  subscribed: t.boolean(),
  token: t.string()
});
var H = /* @__PURE__ */ ((r) => (r.male = "male", r.female = "female", r))(H || {});
const Gt = t.object({
  country: t.string().optional(),
  language: t.string().optional(),
  gender: t.nativeEnum(H).optional()
}).optional(), Kt = (r) => async (n, o) => {
  const s = P(n);
  m(
    Gt,
    o,
    "subscribeToNewsletter"
  );
  const u = await r.transporter.request({
    url: `newsletter-subscription/${s}`,
    data: o || {},
    method: i.POST
  });
  return a(
    u,
    Qt,
    l,
    "paymentFieldsUpdate"
  );
}, Jt = t.object({
  itemId: t.string(),
  quantity: t.number().optional(),
  productUrl: t.string().optional()
}), Xt = (r) => async (n) => {
  m(Jt, n, "postItem");
  const o = await r.transporter.request({
    url: `/items/${n.itemId}/quantity/${n.quantity}`,
    data: {
      productUrl: n.productUrl
    },
    method: i.POST
  });
  return a(
    o,
    p,
    l,
    "postItem"
  );
}, L = t.object({
  lineId: t.string(),
  quantity: t.number().optional()
}), Yt = (r) => async (n) => {
  m(L, n, "deleteItem");
  const o = await r.transporter.request({
    url: `/lines/${n.lineId}/quantity/${n.quantity}`,
    method: i.DELETE
  });
  return a(
    o,
    p,
    l,
    "deleteItem"
  );
}, Zt = t.object({
  categories: t.array(t.string()).optional(),
  search: t.string().optional(),
  onlyAvailable: t.boolean().optional(),
  showAsNew: t.boolean().optional(),
  showAsOnSale: t.boolean().optional(),
  products: t.array(t.string()).optional(),
  skipFirst: t.number().int().default(0).optional(),
  limit: t.number().int().default(20).optional(),
  sortOrder: t.array(
    t.object({
      field: t.enum([
        "uri",
        "categoryItemSort",
        "collectionUri",
        "priceAsNumber",
        "createdAt",
        "modifiedAt"
      ]),
      order: t.enum(["asc", "desc"]).optional()
    })
  ).optional()
}).passthrough(), te = t.array(
  t.object({
    data: t.union([
      t.string(),
      t.object({
        // "brands" field contains this field for filtering by the internal brand ID
        brand: t.string().optional(),
        // "categories" field contains this field for filtering by the internal category ID
        category: t.string().optional(),
        metaDescription: t.string().optional(),
        metaKeywords: t.string().optional(),
        metaTitle: t.string().optional(),
        hex: t.string().optional(),
        desc: t.string().optional(),
        name: t.union([t.string(), t.string().array()]).optional(),
        uri: t.string().optional()
      }).passthrough()
    ]).optional(),
    value: t.string().optional().describe("The value that should be used for the filter search"),
    count: t.number().optional().describe(
      "Items matching this filter option, combined with all filter methods applied"
    ),
    filterCount: t.number().optional().describe(
      "Items matching this filter option, with all other filter methods included except the filter method it belongs to"
    ),
    totalCount: t.number().optional().describe(
      "Items matching this filter option, with all filter methods excluded"
    )
  })
), ee = t.object({
  field: t.string().optional().describe("Name for this filter method"),
  values: te
}), ne = g.extend({
  products: t.array(b),
  productCount: t.number(),
  filter: t.array(ee)
}), re = (r) => async (n) => {
  m(Zt, n, "getProducts");
  const o = await r.transporter.request({
    url: "products",
    data: n,
    method: i.POST
  });
  return a(
    o,
    ne,
    l,
    "getProducts"
  );
};
function oe(r, n) {
  return n && Object.keys(n).forEach((o) => {
    r[o] = n[o](r);
  }), r;
}
const se = (r) => async (n) => {
  const o = await r.transporter.request({
    url: `/shipping-methods/${n.shippingMethod}`,
    method: i.PUT
  });
  return a(
    o,
    p,
    l,
    "addWishlistItem"
  );
}, ie = (r) => async (n, o) => {
  const s = o ? `/countries/${n}/states/${o}` : `/countries/${n}`, u = await r.transporter.request({
    url: s,
    method: i.PUT
  });
  return a(
    u,
    p,
    l,
    "setCountry"
  );
}, ae = g.extend({
  countries: t.array(y)
}), ce = (r) => async () => {
  const n = await r.transporter.request({
    url: "/countries",
    method: i.GET
  });
  return a(
    n,
    ae,
    l,
    "getCountries"
  );
}, le = (r) => async (n) => {
  m(L, n, "updateItem");
  const o = await r.transporter.request({
    url: `/lines/${n.lineId}/quantity/${n.quantity}`,
    method: i.PUT
  });
  return a(
    o,
    p,
    l,
    "updateItem"
  );
}, ue = t.object({
  quantity: t.number(),
  section: t.number(),
  products: t.array(t.number())
}), pe = t.object({
  priceType: t.string(),
  type: t.string(),
  bundle: t.number(),
  sections: t.array(ue),
  priceOfItems: t.string(),
  priceMin: t.string(),
  priceMax: t.string(),
  priceOfItemsAsNumber: t.number(),
  priceMinAsNumber: t.number(),
  priceMaxAsNumber: t.number(),
  priceMinBeforeDiscountAsNumber: t.number(),
  priceMaxBeforeDiscountAsNumber: t.number(),
  priceMinBeforeDiscount: t.string(),
  priceMaxBeforeDiscount: t.string(),
  discount: t.number()
}), me = b.extend({
  bundleInfo: pe
}), de = g.extend({
  bundle: me,
  sectionProducts: t.array(b)
}), ge = (r) => async (n) => {
  const o = await r.transporter.request({
    url: `bundles/${n.id}`,
    data: {
      includeSectionProducts: !0
    },
    method: i.POST
  });
  return a(
    o,
    de,
    l,
    "getBundle"
  );
}, be = t.object({
  item: t.string(),
  sections: t.array(
    t.object({
      section: t.number(),
      item: t.string()
    })
  )
}), he = (r) => async (n) => {
  m(be, n, "postBundle");
  const o = await r.transporter.request({
    url: `/items/bundles/${n.item}`,
    data: {
      item: n.item,
      sections: n.sections
    },
    method: i.POST
  });
  return a(
    o,
    p,
    l,
    "postBundle"
  );
}, ye = t.array(
  t.object({
    item: t.string(),
    quantity: t.number().optional()
  })
), fe = (r) => async (n) => {
  m(ye, n, "postItems");
  const o = await r.transporter.request({
    url: "/items",
    method: i.PUT,
    data: { items: n }
  });
  return a(
    o,
    p,
    l,
    "postItems"
  );
}, Se = (r) => async (n) => {
  const o = await r.transporter.request({
    url: `/vouchers/${n}`,
    method: i.DELETE
  });
  return a(
    o,
    p,
    l,
    "postVouchers"
  );
}, Pe = (r) => async (n) => {
  const o = await r.transporter.request({
    url: "/vouchers",
    data: {
      voucher: n
    },
    method: i.POST
  });
  return a(
    o,
    p,
    l,
    "postVouchers"
  );
};
function Ie(r) {
  const n = {
    transporter: G(r),
    options: r
  };
  return {
    getTokenHandler: () => r.centraTokenHandler,
    ...oe(n, {
      subscribeToNewsletter: Kt,
      subscribeToBackInStock: Vt,
      register: mt,
      login: dt,
      logout: ht,
      getCustomerOrders: bt,
      getCustomerData: Ot,
      updateCustomerInfo: ft,
      updateCustomerEmail: St,
      resetPassword: Nt,
      sendResetPasswordEmail: Tt,
      updatePassword: At,
      getCustomerWishlistItems: wt,
      addWishlistItem: kt,
      deleteWishlistItem: It,
      getSelection: Mt,
      postPayment: Ut,
      setShippingMethod: se,
      paymentResult: Wt,
      paymentFieldsUpdate: Lt,
      postItem: Xt,
      deleteItem: Yt,
      updateItem: le,
      getProducts: re,
      setCountry: ie,
      getCountries: ce,
      getBundle: ge,
      postBundle: he,
      postItems: fe,
      deleteVouchers: Se,
      postVouchers: Pe
    })
  };
}
const Ne = 3600 * 24 * 7, Te = "centra-api-token";
class Oe {
  constructor(n = Ne, o = Te) {
    this.ttl = n, this.tokenName = o;
  }
  getToken() {
    return A.getWithExpiry(this.tokenName);
  }
  setToken(n) {
    A.setWithExpiry(this.tokenName, n, this.ttl);
  }
  removeToken() {
    A.remove(this.tokenName);
  }
}
const Me = t.object({
  limit: t.number().optional(),
  page: t.number().optional(),
  wishlist: t.string().optional()
}), Ce = t.object({
  wishlist: t.string().optional(),
  item: t.string()
}), De = t.object({
  paymentMethodFields: t.record(t.string(), t.unknown()).optional()
}), qe = t.object({
  shippingMethod: t.string()
});
function xe(r) {
  var n, o, s, u, d, N;
  return (r == null ? void 0 : r.status) >= 400 && typeof ((o = (n = r == null ? void 0 : r.response) == null ? void 0 : n.data) == null ? void 0 : o.errors) == "object" && ((u = (s = r == null ? void 0 : r.response) == null ? void 0 : s.data) == null ? void 0 : u.errors) !== null && Object.keys((N = (d = r == null ? void 0 : r.response) == null ? void 0 : d.data) == null ? void 0 : N.errors).length > 0;
}
export {
  Oe as CentraLocalStorageTokenHandler,
  i as Method,
  H as SubscribeToNewsletterGenderEnum,
  Q as Transport,
  kt as addWishlistItem,
  f as addressSchema,
  ot as bundleInfoModelSchema,
  et as bundleInfoSchema,
  st as bundleModelSchema,
  X as categorySchema,
  me as centraCheckoutApiBundleProductSchema,
  x as centraCheckoutApiProductBaseSchema,
  tt as centraCheckoutApiProductItemSchema,
  b as centraCheckoutApiProductSchema,
  rt as centraCheckoutApiRelatedProductSchema,
  ee as centraFilterResponse,
  te as centraFilterValuesSchema,
  Zt as centraGetProductsPayloadSchema,
  _t as centraSubscribeToBackInStockOptionsSchema,
  Gt as centraSubscribeToNewsletterOptionsSchema,
  w as consentSchema,
  y as countrySchema,
  Ie as createCentraCheckoutAPIClient,
  G as createTransporter,
  R as currencyModelSchema,
  V as defaultLogger,
  Yt as deleteItem,
  It as deleteWishlistItem,
  l as errorsResponseSchema,
  pt as errorsSchema,
  de as getBundleResponseSchema,
  Ot as getCustomerData,
  bt as getCustomerOrders,
  wt as getCustomerWishlistItems,
  Me as getCustomerWishlistOptionsSchema,
  re as getProducts,
  ne as getProductsResponseSchema,
  Mt as getSelection,
  xe as isCentraErrorsResponse,
  it as itemBundleInfoSchema,
  h as languageSchema,
  S as locationSchema,
  q as loggedInBaseSchema,
  k as loggedInSchema,
  dt as login,
  ht as logout,
  zt as orderCreatedErrorsResponseSchema,
  Ft as orderCreatedResponseSchema,
  $t as orderCreatedSelectionNotFoundErrorSchema,
  C as orderResponseSchema,
  z as orderSchema,
  gt as ordersPagingSchema,
  c as paymentFieldModelSchema,
  F as paymentFieldsModelSchema,
  Lt as paymentFieldsUpdate,
  Ht as paymentFieldsUpdateOptionsSchema,
  U as paymentMethodModelSchema,
  vt as paymentResponseErrorPaymentMethodFailedSchema,
  Bt as paymentResponseErrorSchema,
  Rt as paymentResponseErrorUnavailableItemsSchema,
  Ct as paymentResponseFormTypeSchema,
  Dt as paymentResponseJavascriptTypeSchema,
  qt as paymentResponseRedirectTypeSchema,
  Et as paymentResponseSuccessSchema,
  xt as paymentResponseSuccessTypeSchema,
  Wt as paymentResult,
  De as paymentResultOptionsSchema,
  Xt as postItem,
  Ut as postPayment,
  D as postPaymentAddressSchema,
  W as postPaymentOptionsSchema,
  mt as register,
  J as registerOptionsSchema,
  Nt as resetPassword,
  Pt as resetPasswordOptionsSchema,
  ut as selectionAutoDiscountSchema,
  at as selectionBundleModelSchema,
  E as selectionItemModelSchema,
  ct as selectionModelItemSchema,
  M as selectionModelPluginFieldsIngridSchema,
  lt as selectionModelPluginFieldsSchema,
  B as selectionModelSchema,
  p as selectionResponseSchema,
  v as selectionVoucherSchema,
  Tt as sendResetPasswordEmail,
  se as setShippingMethod,
  qe as setShippingMethodOptionsSchema,
  $ as shippingMethodModelSchema,
  Vt as subscribeToBackInStock,
  Kt as subscribeToNewsletter,
  Qt as subscribedToNewsletterResponseSchema,
  nt as tableMappingSchema,
  g as tokenResponseSchema,
  St as updateCustomerEmail,
  ft as updateCustomerInfo,
  yt as updateCustomerOptionsSchema,
  Ce as updateCustomerWishlistOptionsSchema,
  L as updateItemOptionsSchema,
  At as updatePassword,
  O as wishlistBasePath,
  I as wishlistResponseSchema
};
